import { Grid, Tooltip } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { useTranslation } from "react-i18next";

const ManageFolderImageItem = (props) => {
  const { t } = useTranslation();
  return (
    <Grid item>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            position: "relative",
          }}
        >
          <img
            onClick={() => props.handleSelectFolder(props.folder)}
            src="/folder.svg"
            alt=""
            width={200}
          />
          <div
            style={{
              position: "absolute",
              top: "23px",
              left: "20px",
              display: "flex",
              cursor: "pointer",
              gap: "6px",
            }}
          >
            <Tooltip
              title={t("common.upload.editFolder")}
              placement="top"
              arrow
              onClick={() => props.handleOpenDialogFolder("edit", props.folder)}
            >
              <EditIcon fontSize="small" htmlColor="#485460" />
            </Tooltip>
            <Tooltip
              title={t("common.upload.deleteFolder")}
              placement="top"
              arrow
              onClick={() => props.handleDeleteFolder(props.folder)}
            >
              <CloseIcon fontSize="small" htmlColor="#485460" />
            </Tooltip>
          </div>
        </div>
        <span
          style={{
            marginTop: "-20px",
            maxWidth: "150px",
            // overflow: 'hidden',
            textAlign: "center",
          }}
        >
          {props.folder.folder_name}
        </span>
      </div>
    </Grid>
  );
};

export default ManageFolderImageItem;
